import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';
import { message } from 'antd';
import { nullSafeGet, nullSafeGetOrElse } from '../utils/DataAccessUtils';

const fetchUtils = new FetchUtils();

const returnData =
	(dispatch) =>
	(baseUrl, apiUrl, formatter = (data) => returnGeneral(data)) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(
					baseUrl + apiUrl,
					Object.assign(
						{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
						{}
					)
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
						message.error(d.data);
					} else {
						resolve(formatter(d.data));
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};

const returnComparison = (valueName) => (data) => {
	return {
		value: nullSafeGetOrElse(`0.${valueName}`, data, 0),
		pastValue: nullSafeGetOrElse(`1.${valueName}`, data, 0),
	};
};

const returnCount = (valueName) => (data) => {
	return {
		value: nullSafeGetOrElse(valueName, data, 0),
		detailParams: `woPriorityIds=${nullSafeGet('workOrderPriorityId', data)}`,
	};
};

const returnGeneral = (data) => {
	return { value: data };
};

export const getWorkOrdersCreatedCount = (userType) => (startDate, endDate) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/dashboard/attention_dashboards/work_order_created/${startDate}/${endDate}`;
	return (dispatch) => {
		return returnData(dispatch)(baseUrl, apiUrl, returnComparison(`count`));
	};
};

export const getWorkOrdersCompletedCount = (userType) => (startDate, endDate) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/dashboard/attention_dashboards/work_order_completed/${startDate}/${endDate}`;
	return (dispatch) => {
		return returnData(dispatch)(baseUrl, apiUrl, returnComparison(`count`));
	};
};

export const getWorkOrdersCompletionRate = (userType) => (startDate, endDate) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/dashboard/attention_dashboards/work_order_completion_rate/${startDate}/${endDate}`;
	return (dispatch) => {
		return returnData(dispatch)(baseUrl, apiUrl, returnComparison(`rate`));
	};
};

export const getWorkOrdersAverageCompletionLag = (userType) => (startDate, endDate) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/dashboard/attention_dashboards/work_order_average_completion_lag/${startDate}/${endDate}`;
	return (dispatch) => {
		return returnData(dispatch)(baseUrl, apiUrl, returnComparison(`seconds`));
	};
};

export const getImportantUnreadNotificationCount = (userType) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/dashboard/attention_dashboards/unread_important_notification_count`;
	return (dispatch) => {
		return returnData(dispatch)(baseUrl, apiUrl);
	};
};

export const getApprovalWaitingOnCount = (userType) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/dashboard/attention_dashboards/approval_waiting_on_count`;
	return (dispatch) => {
		return returnData(dispatch)(baseUrl, apiUrl);
	};
};

export const getActiveEmergencyWorkOrderCount = (userType) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/dashboard/attention_dashboards/active_emergency_work_order_count`;
	return (dispatch) => {
		return returnData(dispatch)(baseUrl, apiUrl, returnCount('count'));
	};
};

export const getStaleWorkOrderCount = (userType) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/dashboard/attention_dashboards/stale_work_order_count`;
	return (dispatch) => {
		return returnData(dispatch)(baseUrl, apiUrl);
	};
};
